import { get, post, postMultipart, fetchBlob, postWithCustomHeaders } from "./apiService";

const API_PATHS = {
    PING: "/ping",
    LOGIN: "/api/auth/login",
    LOGOUT_USER: "/api/auth/logout",
    USER_QUERY: "/glassyfied/user-query",
    CHAT_HISTORY: "/glassyfied/chat-history",
    MD_TO_IMAGE: "/glassyfied/md-to-image",
    MD_TO_PDF: "/glassyfied/md-to-pdf",
    FEEDBACK: "/glassyfied/feedback",
    GET_BOOKMARKS: "/glassyfied/get-bookmarks",
    REGISTERED_USER_CONTACT_SUBMISSION: "/glassyfied/registered-contact-submission",
    GET_REGISTERED_USERS_CONTACT_SUBMISSIONS: "/glassyfied/contact-submission",
    HTML_TO_IMAGE: "/glassyfied/html-to-image",
    HTML_TO_PDF: "/glassyfied/html-to-pdf",
    CONTACT_US_SUBMISSION: "/glassyfied/contact-us",
    FIREBASE_CONFIG: "/api/auth/firebase-config",
};

export const pingService = () => get(`${API_PATHS.PING}`);

export const loginFirebase = (data) => postWithCustomHeaders(`${API_PATHS.LOGIN}`, data, { "X-Auth-Type": "firebase" }, false);

export const logoutUser = () => post(`${API_PATHS.LOGOUT_USER}`, {}, true);

export const userQuery = (formData) => postMultipart(API_PATHS.USER_QUERY, formData, true);

export const chatHistory = () => get(`${API_PATHS.CHAT_HISTORY}`, true);

export const markdownToImage = (data) => fetchBlob(`${API_PATHS.MD_TO_IMAGE}`, data, true);

export const markdownToPDF = (data) => fetchBlob(`${API_PATHS.MD_TO_PDF}`, data, true);

export const userFeedback = (data) => post(`${API_PATHS.FEEDBACK}`, data, true);

export const getBookmarks = () => get(`${API_PATHS.GET_BOOKMARKS}`, true);

export const registeredUserContactSubmission = (data) => post(`${API_PATHS.REGISTERED_USER_CONTACT_SUBMISSION}`, data, true);

export const getRegisteredUserContactSubmissions = () => get(`${API_PATHS.GET_REGISTERED_USERS_CONTACT_SUBMISSIONS}`, true);

export const htmlToImage = (data) => fetchBlob(`${API_PATHS.HTML_TO_IMAGE}`, data, true);

export const htmlToPDF = (data) => fetchBlob(`${API_PATHS.HTML_TO_PDF}`, data, true);

export const contactUsSubmission = (data) => post(`${API_PATHS.CONTACT_US_SUBMISSION}`, data, false);

export const firebaseConfig = () => get(`${API_PATHS.FIREBASE_CONFIG}`);
